module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zone ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.form.zoneId),
      callback: function($$v) {
        _vm.$set(_vm.form, "zoneId", $$v)
      },
      expression: "form.zoneId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Software Version"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.form.softwareVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "softwareVersion", $$v)
      },
      expression: "form.softwareVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bacnet"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.bacnetEnabledCheckboxChange
    },
    model: {
      value: (_vm.form.bacnetEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "bacnetEnabled", $$v)
      },
      expression: "form.bacnetEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveDataToPanel
    }
  }, [_vm._v("Save to Panel")])], 1), _vm._v(" "), _c('input', {
    ref: "hidden",
    staticStyle: {
      "color": "white",
      "outline": "none",
      "border": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ca2f128"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/System.vue
// module id = 1404
// module chunks = 1